import { Box, Tooltip, Typography } from "@mui/material";
import { DeveloperTrack } from "@/modules/leads/types";
import { muiTheme } from "@/styles/theme";
import { useState } from "react";

const MAX_VISIBLE_TRACKS = 1;

const TrackChip = ({ track }: { track: DeveloperTrack }) => (
  <Box
    display="flex"
    alignItems="center"
    sx={{
      color: muiTheme.colorSchemes.light.palette.primary[500],
      border: `1px solid ${muiTheme.colorSchemes.light.palette.primary[500]}`,
      backgroundColor: "transparent",
      padding: "2px 8px",
      borderRadius: "12px",
      whiteSpace: "nowrap",
      fontSize: "0.75rem",
      textTransform: "capitalize",
      flexShrink: 0,
      lineHeight: 1.2,
    }}
  >
    <Typography
      variant="body_sm_reg"
      sx={{ fontSize: "0.75rem", textTransform: "capitalize" }}
    >
      {track.name}
    </Typography>
  </Box>
);

const DeveloperTracksChips = ({ tracks }: { tracks?: DeveloperTrack[] }) => {
  const [expanded, setExpanded] = useState(false);

  if (!tracks || tracks.length === 0) return null;

  const visibleTracks = expanded ? tracks : tracks.slice(0, MAX_VISIBLE_TRACKS);
  const hiddenCount = tracks.length - MAX_VISIBLE_TRACKS;

  return (
    <Box
      sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", alignItems: "center" }}
    >
      {visibleTracks.map((track) => (
        <TrackChip key={track.uid} track={track} />
      ))}
      {hiddenCount > 0 && (
        <Tooltip
          title={
            expanded
              ? "Show less"
              : tracks
                  .slice(MAX_VISIBLE_TRACKS)
                  .map((t) => t.name)
                  .join(", ")
          }
        >
          <Box
            onClick={(e) => {
              e.stopPropagation();
              setExpanded((prev) => !prev);
            }}
            sx={{
              color: muiTheme.colorSchemes.light.palette.primary[500],
              border: `1px solid ${muiTheme.colorSchemes.light.palette.primary[300]}`,
              backgroundColor: muiTheme.colorSchemes.light.palette.primary[50],
              padding: "2px 8px",
              borderRadius: "12px",
              whiteSpace: "nowrap",
              fontSize: "0.75rem",
              cursor: "pointer",
              lineHeight: 1.2,
              "&:hover": {
                backgroundColor: muiTheme.colorSchemes.light.palette.primary[100],
              },
            }}
          >
            {expanded ? "show less" : `+${hiddenCount} more`}
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default DeveloperTracksChips;
